import { Page404 } from "pages/page-404";
import { ReactElement, useContext } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import styles from "./InternationalSolutionsPage.module.css";
import Contractor from "./pages/Contractor/Contractor";
import EmployerOfRecord from "./pages/EmployerOfRecord/EmployerOfRecord";
import { CONTRACTORS_PATH, EMPLOYEES_EOR_PATH } from "./routes";
import { NeonSkyContext } from "lib/neon-sky/neon-sky-provider";
import { buildASOPath } from "lib/resource-finder";

const redirectToNeon = (pathname = "") => {
  const targetPath = pathname.toLowerCase();
  const basePath = "/product-details/international-solutions";
  const memberType = targetPath.includes(CONTRACTORS_PATH)
    ? "/contractors"
    : "/employer-of-record";

  const endPaths = ["/overview", "/faq", "/resources"];
  const endPath =
    endPaths.find(
      (path) => targetPath.endsWith(path) || targetPath.endsWith(path + "/")
    ) || "";

  window.location.replace(buildASOPath(basePath + memberType + endPath));
};

const InternationalSolutionsPage = (): ReactElement => {
  const { featureFlags } = useContext(NeonSkyContext);
  const { pathname } = useLocation();

  if (featureFlags.neonmoose_global_international_pdp) {
    redirectToNeon(pathname);
    return <></>;
  }

  return (
    <div className={styles.contentWrapper}>
      <Routes>
        <Route
          path={`${EMPLOYEES_EOR_PATH}/*`}
          element={<EmployerOfRecord />}
        />
        <Route path={`${CONTRACTORS_PATH}/*`} element={<Contractor />} />
        <Route
          path="/"
          element={<Navigate to={`${EMPLOYEES_EOR_PATH}`} replace />}
        />
        <Route path="*" element={<Page404 />} />
      </Routes>
    </div>
  );
};

export default InternationalSolutionsPage;
